import { Box, Stack } from '@mui/material';

export type CatalogFilterProps = {
    /** The catalogue headings to narrow down to. */
    groups: string[];
    /** The chosen heading; `undefined` shows every group. */
    selected?: string;
    allLabel: string;
    onSelect: (group?: string) => void;
};

/** Toggle chips that narrow a catalogue to one of its headings. */
export function CatalogFilter({ groups, selected, allLabel, onSelect }: CatalogFilterProps) {
    return (
        <Stack role="group" aria-label="Filter" direction="row" flexWrap="wrap" gap={ 1 }>
            <Chip label={ allLabel } pressed={ !selected } onClick={ () => onSelect(undefined) }/>
            { groups.map((group) => (
                <Chip key={ group } label={ group } pressed={ group === selected } onClick={ () => onSelect(group) }/>
            )) }
        </Stack>
    );
}

type ChipProps = {
    label: string;
    pressed: boolean;
    onClick: () => void;
};

function Chip({ label, pressed, onClick }: ChipProps) {
    return (
        <Box component="button" type="button" aria-pressed={ pressed } onClick={ onClick } sx={ {
            height: 36, px: 2, borderRadius: '18px', font: 'inherit', fontSize: 13, cursor: 'pointer',
            fontWeight: pressed ? 700 : 600,
            border: `1px solid ${ pressed ? '#161C24' : '#CFD6DE' }`,
            bgcolor: pressed ? '#161C24' : '#FFFFFF',
            color: pressed ? '#FFFFFF' : '#161C24',
            '&:focus-visible': { outline: '2px solid #2065D1', outlineOffset: 2 },
        } }>
            { label }
        </Box>
    );
}
